import { render, staticRenderFns } from "./coordinate.vue?vue&type=template&id=8e2a6f30&scoped=true&"
import script from "./coordinate.vue?vue&type=script&lang=js&"
export * from "./coordinate.vue?vue&type=script&lang=js&"
import style0 from "./coordinate.vue?vue&type=style&index=0&id=8e2a6f30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2a6f30",
  null
  
)

export default component.exports